<template>
  <div style="height: 100%; position: relative" class="sidebar-bg">
    <div
      class="sidebar-title"
      :class="{ title2: isCollapse }"
      @click="toWelcome()"
    >
      <template v-if="$name === 'cy'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/cylogo.jpg"
        />
        <p class="sidebar-title-text">{{ "创宇新材料" }}</p>
      </template>
      <template v-else-if="$name === 'xx'">
        <img class="logo" src="@/assets/img/xxlogo.jpg" />
      </template>
      <template v-else-if="$name === 'by'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/bylogo.jpg"
        />
        <p class="sidebar-title-text">{{ "铂悦厨业" }}</p>
      </template>
      <template v-else-if="$name === 'zq'">
        <img class="logo" src="@/assets/img/zqlogo.jpg" />
      </template>
      <template v-else-if="$name === 'ht'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/htlogo.jpg"
        />
        <p class="sidebar-title-text">{{ "海通塑胶" }}</p>
      </template>
      <template v-else-if="$name === 'ps'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/pslogo.jpg"
        />
        <p class="sidebar-title-text">{{ "鹏盛科技" }}</p>
      </template>
      <template v-else-if="$name === 'rrf'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/rrflogo.jpg"
        />
        <p class="sidebar-title-text">{{ "人人福食品" }}</p>
      </template>
      <template v-else-if="$name === 'abl'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/abllogo.jpg"
        />
        <p class="sidebar-title-text">{{ "安百林家具" }}</p>
      </template>
      <template v-else-if="$name === 'wt'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/wtlogo.jpg"
        />
        <p class="sidebar-title-text">{{ "微特电机" }}</p>
      </template>
      <template v-else-if="$name === 'cn'">
        <img
          class="bylogo"
          style="width: 60px; height: auto"
          src="@/assets/img/cnlogo.png"
        />
        <p class="sidebar-title-text">{{ "楚南新材料" }}</p>
      </template>
      <template v-else-if="$name === 'bl'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/bllogo.jpg"
        />
        <p class="sidebar-title-text">{{ "博隆羽绒" }}</p>
      </template>
      <template v-else-if="$name === 'syzg'">
        <img
          class="bylogo"
          style="width: 70px; height: auto"
          src="@/assets/img/syzglogo.jpg"
        />
        <p class="sidebar-title-text">{{ "三优重工" }}</p>
      </template>
      <template v-else-if="$name === 'xy'">
        <img
          class="bylogo"
          style="width: 40px; height: auto"
          src="@/assets/img/xy.jpg"
        />
        <p class="sidebar-title-text">{{ "鑫翊新材料" }}</p>
      </template>
      <!-- <img :src="logoImage" style="width: 32px; height: 32px; border-radius: 50%;" />
      <p class="sidebar-title-text">{{getProjectName()}}</p> -->
      <!-- <p class="sidebar-title-text">睿新工业互联网平台</p> -->
      <!-- <p class="sidebar-title-text">智造云平台</p> -->
    </div>
    <div class="left-menu" style="height: calc(100% - 120px)">
      <el-scrollbar wrap-class="scrollbar_dropdown__wrap" style="height: 100%">
        <!-- :active-text-color="activeTextColor" -->
        <!-- :collapse="getCollapse" -->
        <el-menu
          ref="menu"
          mode="vertical"
          class="el-menu-vertical-demo"
          :default-active="getCurrentMenuId"
          :unique-opened="true"
          @select="selectMenu"
          :collapse="isCollapse"
        >
          <!-- :collapse="isCollapse" background-color="rgba(29, 133, 253, 1)" text-color="#fff" active-text-color="rgba(28, 132, 253, 1)"> -->
          <template v-for="menu in getMenuList">
            <!-- <menu-item :menu="menu" :key="menu.menuId" /> -->
            <el-menu-item
              ref="item"
              :index="menu.menuId + ''"
              :key="menu.menuId"
              v-if="menu.children == null || menu.children.length <= 0"
            >
              <template slot="title">
                <i
                  v-if="menu.icon"
                  :class="menu.icon"
                  style="margin-right: 5px; font-size: 18px"
                  :style="getIconStyle(menu.icon)"
                ></i>
                <span slot="title" :style="getTextStyle(!menu.icon)">{{
                  menu.menuName
                }}</span>
              </template>
            </el-menu-item>
            <el-submenu v-else :index="menu.menuId + ''" :key="menu.menuId">
              <template slot="title">
                <i
                  v-if="menu.icon"
                  :class="menu.icon"
                  style="margin-right: 5px; font-size: 18px"
                  :style="getIconStyle(menu.icon)"
                ></i>
                <span
                  slot="title"
                  :style="getTextStyle(!menu.icon)"
                  v-show="!getCollapse"
                  >{{ menu.menuName }}</span
                >
              </template>
              <template v-for="child in menu.children">
                <menu-item
                  class="nest-menu"
                  :menu="child"
                  :isChild="true"
                  :key="child.menuId"
                />
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </el-scrollbar>
    </div>
    <div class="left-box-bottom">
      <img
        v-if="!isCollapse"
        src="@/assets/img/item.png"
        alt=""
        srcset=""
        @click="isCollapse = !isCollapse"
      />
      <img
        v-else
        src="@/assets/img/item2.png"
        alt=""
        srcset=""
        @click="isCollapse = !isCollapse"
      />
    </div>
  </div>
</template>

<script>
import menuItem from "./menu-item.vue";
import { mapGetters, mapMutations } from "vuex";
import projectConfig from "@/core/config";

export default {
  data() {
    return {
      isCollapse: false,
      collapseLeft: "200px",
      showCollapseBtn: true,
      logoImage: require("../../../../assets/img/logo.png"),
    };
  },
  components: {
    "menu-item": menuItem,
  },
  computed: {
    activeTextColor() {
      return undefined;
    },
    getCollapseStyle() {
      return [
        {
          left: this.collapseLeft,
        },
      ];
    },
    ...mapGetters([
      "getMultiTags",
      "getMenuList",
      "getCollapse",
      "getCurrentMenuPath",
      "getCurrentMenuId",
      "getMultiColumn",
    ]),
  },
  methods: {
    toWelcome() {
      this.$router.push({ name: "welcome" });
    },
    getIconStyle(isShow) {
      if (isShow && this.isChild) {
        return [{ "margin-left": "13px" }];
      }
    },
    getTextStyle(isShow) {
      if (isShow && this.isChild) {
        return [{ "padding-left": "13px" }];
      }
    },
    onCollapseChange() {
      this.showCollapseBtn = false;
      setTimeout(() => {
        this.setCollapse(!this.getCollapse);
        this.collapseLeft = this.getCollapse ? "65px" : "200px";
        this.showCollapseBtn = true;
      }, 100);
    },
    getProjectName() {
      if (this.getCollapse) {
        return projectConfig.projectName.substr(0, 1);
      } else {
        return projectConfig.projectName;
      }
    },
    selectMenu(index, path) {
      console.log("getMenuList", this.getMenuList);
      console.log("--- selectMenu ----", index);
      if (this.getCurrentMenuId === index) return;
      // 单页面清空所有tags和cachePage
      if (!this.getMultiTags) {
        this.clearAllTags();
      }
      this.setCurrentMenuId(index);
    },
    ...mapMutations(["setCollapse", "clearAllTags", "setCurrentMenuId"]),
  },
};
</script>

<style scoped lang="scss">
.sidebar-title {
  cursor: pointer;
}
.sidebar-title-text {
  font-size: 18px;
  font-weight: bold;
}

// ::v-deep .el-menu-item.is-active {
//   background-color: rgba(248, 249, 253, 1) !important;
// }

.left-box-bottom {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: right;
  padding: 0 24px;
  box-sizing: border-box;

  img {
    cursor: pointer;
  }
}

.logo {
  width: auto;
  height: 55px;
  text-align: center;
  margin: 0 auto;
}
.title2 {
  width: 6px;
  height: 60px;
  padding: 0 16px;
  margin: 0;
  border: 0;

  // img {
  //   // width: 130px !important;
  //   // height: 0 !important;
  //   height: 45px !important;
  // }

  .logo {
    height: 45px !important;
  }
  .bylogo {
    width: 40px !important;
    height: auto !important;
  }
}
.title2 p {
  display: none;
}
</style>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
}
.el-submenu__title {
  border-radius: 30px 0 0 30px;
  overflow: hidden;
}
.nest-menu {
  border-radius: 30px 0 0 30px;
  overflow: hidden;
}
</style>
